<template>
    <div class="page-container dashboard-page">
        <div class="page-content">
            <div class="left-side-container">
                <div class="page-header">
                    <h1>Dashboard</h1>
                </div>
                
                <div class="reports-widget">
                    <div class="reports-widget-header">
                        <h2>Reports</h2>

                        <router-link to="/reports" class="zoom-out-btn">
                            <i class="icon icon-zoom-out"></i>
                        </router-link>
                    </div>
                    <div class="reports-widget-tip" v-html="chartText"></div>

                    <MainChart :chartData="chartData" :format="chartFormat">
                        <template slot="label"><div></div></template>
                    </MainChart>
                </div>

                <div class="accounts-list">
                    <div class="accounts-title">
                        <h1>{{ $t('Ваши счета') }}</h1>
                    </div>

                    <div class="accounts-list-container">
                        <div class="account-widget-loader" v-if="! isAccountsLoaded">
                            <div class="account-widget-container">
                                <div class="account-widget-header">
                                    <div class="account-widget-title"></div>
                                </div>

                                <div class="account-widget-content">
                                    <div class="account-widget-amount"></div>
                                </div>
                            </div>
                        </div>
                        <AccountWidget :account="account" v-for="account in accounts" :key="account.id" />
                        <div class="account-widget-new" @click="openNewAccountForm()">
                            <div class="account-widget-new-container">
                                <div class="account-widget-new-icon">
                                    <i class="icon icon-accounts"></i>
                                </div>
                                <div class="account-widget-new-text">
                                    <div class="account-widget-new-title">
                                        New Account
                                    </div>
                                    <div class="account-widget-new-tip">
                                        You have no card added
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="statement">
                    <div class="statement-header">
                        <h1>{{ $t('Траты') }}</h1>

                        <router-link to="/statement" class="statement-search-btn">
                            <i class="icon icon-search"></i>
                        </router-link>

                        <button @click="openNewTransactionForm()" class="btn statement-btn-add">
                            <i class="icon icon-plus"></i>
                            <span>{{ $t('Добавить операцию') }}</span>
                        </button>

                        <button class="btn statement-btn-settings">
                            <i class="icon icon-settings"></i>
                        </button>
                    </div>

                    <StatementBlock :group="group" v-for="(group, index) in transactions" :key="index"/>
                </div>
            </div>

            <div class="right-side-container sticky">
                <RightSideUserControls />
                
                <div class="widgets-container">
                    <div :class="{'info-widget': true, 'flip': infoWidgetToggle}">
                        <div class="info-widget-front">
                            <button type="button" @click="infoWidgetToggle = !infoWidgetToggle" class="widget-controls-btn">
                                <i class="icon icon-settings"></i>
                            </button>

                            <div class="widget-slots">
                                <template v-for="(widget, index) in widgets">
                                    <div class="widget-slot" :key="`widget-${index}`" v-if="widget !== null">
                                        <component 
                                            v-bind:is="widget.component"
                                            :title="widget.title"
                                            :data="widget.data"
                                            >
                                        </component>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <div class="info-widget-back">
                            <button type="button" @click="infoWidgetToggle = !infoWidgetToggle" class="widget-controls-btn">
                                <i class="icon icon-settings"></i>
                            </button>
                            
                            <div class="widget-slots">
                                <div class="widget-slot">
                                    <div class="widget-title">
                                        {{ $t('Выберите виджеты') }}
                                    </div>
                                    <div class="widget-controls-form-group">
                                        <multiselect v-model="selectedWidgets.first" :searchable="false" :options="availableWidgets" label="title" track-by="type" class="form-control">
                                            <template slot="singleLabel" class="signle-lable" slot-scope="props">
                                                <div class="label">
                                                    <span>{{ props.option.title }}</span>
                                                </div>
                                            </template>
                                            <template slot="caret">
                                                <div class="caret">
                                                    <i class="icon icon-chevron-down"></i>
                                                </div>
                                            </template>
                                            <template slot="placeholder" slot-scope="props">
                                                <div class="placeholder">
                                                    <span>{{ $t('Первый виджет') }}</span>
                                                </div>
                                            </template>
                                        </multiselect>
                                    </div>
                                    <div class="widget-controls-form-group">
                                        <multiselect v-model="selectedWidgets.second" :searchable="false" :options="availableWidgets" label="title" track-by="type" class="form-control">
                                            <template slot="singleLabel" class="signle-lable" slot-scope="props">
                                                <div class="label">
                                                    <span>{{ props.option.title }}</span>
                                                </div>
                                            </template>
                                            <template slot="caret">
                                                <div class="caret">
                                                    <i class="icon icon-chevron-down"></i>
                                                </div>
                                            </template>
                                            <template slot="placeholder" slot-scope="props">
                                                <div class="placeholder">
                                                    <span>{{ $t('Второй виджет') }}</span>
                                                </div>
                                            </template>
                                        </multiselect>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="mini-reports-widget">
                        <div class="mini-reports-widget-header">
                            <h2>Reports</h2>

                            <a href="#" class="zoom-out-btn">
                                <i class="icon icon-zoom-out"></i>
                            </a>
                        </div>
                    </div>
                </div>


                <div class="reminders-widget">
                    <div class="reminders-widget-header">
                        <h2>{{ $t('Напоминания') }}</h2>

                        <a href="#" @click.prevent="openNewReminderForm()" class="new-reminder-btn">
                            <i class="icon icon-plus"></i>
                        </a>
                    </div>
                    <div class="reminders-widget-container">
                        <ReminderWidgetItem @open="openReminder" :reminder="reminder" v-for="reminder in reminders.actual" :key="reminder.id" />
                    </div>
                </div>
            </div>
        </div>

        <MobilePlusBtn type="new-transaction" />
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { EventBus } from "@/event-bus.js";

import AccountWidget from "@/new/components/Accounts/AccountWidget.vue";
import ReminderWidgetItem from "@/new/components/Reminders/ReminderWidgetItem.vue";
import StatementBlock from "@/new/components/Statement/StatementBlock.vue";
import MainChart from "@/new/components/Reports/MainChart.vue";
import RightSideUserControls from "@/new/components/RightSideUserControls.vue";
import MobilePlusBtn from "@/new/components/MobilePlusBtn.vue";

import TodaySpendsWidget from "@/new/components/Widgets/TodaySpendsWidget.vue";
import MonthSpendsWidget from "@/new/components/Widgets/MonthSpendsWidget.vue";
import WeekSpendsWidget from "@/new/components/Widgets/WeekSpendsWidget.vue";
import TodayIncomesWidget from "@/new/components/Widgets/TodayIncomesWidget.vue";
import MonthIncomesWidget from "@/new/components/Widgets/MonthIncomesWidget.vue";
import WeekIncomesWidget from "@/new/components/Widgets/WeekIncomesWidget.vue";
import ReminderAmountWidget from "@/new/components/Widgets/ReminderAmountWidget.vue";
import TodayAvailableWidget from "@/new/components/Widgets/TodayAvailableWidget.vue";
import BalanceWidget from "@/new/components/Widgets/BalanceWidget.vue";

const WIDGET_POSITION_FIRST = "first";
const WIDGET_POSITION_SECOND = "second";

export default {
    name: "Dashboard",

    components: {
        AccountWidget,
        ReminderWidgetItem,
        StatementBlock,
        RightSideUserControls,
        MobilePlusBtn,
        MainChart,

        TodaySpendsWidget,
        MonthSpendsWidget,
        WeekSpendsWidget,
        TodayIncomesWidget,
        MonthIncomesWidget,
        WeekIncomesWidget,
        ReminderAmountWidget,
        TodayAvailableWidget,
        BalanceWidget
    },

    data: function() {
        return {
            WIDGET_POSITION_FIRST: WIDGET_POSITION_FIRST,
            WIDGET_POSITION_SECOND: WIDGET_POSITION_SECOND,

            balance: null,
            today_spend: null,
            month_spend: null,
            month_limit: null,
            budget_today: 0,
            budget_percent: 0,

            page: 1,

            infoWidgetToggle: false,

            chartText: "",
            chartFormat: "month",
            chartData: [
                {date: "...", value: '0', currency: 'uah', isCurrent: false},
                {date: "...", value: '0', currency: 'uah', isCurrent: false},
                {date: "...", value: '0', currency: 'uah', isCurrent: false},
                {date: "...", value: '0', currency: 'uah', isCurrent: false},
                {date: "...", value: '0', currency: 'uah', isCurrent: false},
                {date: "...", value: '0', currency: 'uah', isCurrent: false},
                {date: "...", value: '0', currency: 'uah', isCurrent: false},
                {date: "...", value: '0', currency: 'uah', isCurrent: false},
                {date: "...", value: '0', currency: 'uah', isCurrent: false},
                {date: "...", value: '0', currency: 'uah', isCurrent: false},
                {date: "...", value: '0', currency: 'uah', isCurrent: false},
                {date: "...", value: '0', currency: 'uah', isCurrent: false},
            ],

            widgets: {
                WIDGET_POSITION_FIRST: null,
                WIDGET_POSITION_SECOND: null,
            },

            availableWidgets: [],
            selectedWidgets: {
                first: null,
                second: null,
            },
        };
    },

    mounted() {
        this.loadAccounts();
        this.loadCategories();
        this.loadReminders();
        this.loadTransactions({per_page: 10, page: 1});
        this.loadDashboard();

        this.loadMainChart();
        this.loadWidgets();
    },

    watch: {
        'selectedWidgets.first': function(widget, oldVal) {
            if(oldVal === null) {
                return;
            }

            this.saveSelectedWidget('first', widget.type);
        },

        'selectedWidgets.second': function(widget, oldVal) {
            if(oldVal === null) {
                return;
            }

            this.saveSelectedWidget('second', widget.type);
        }
    },

    computed: {
        ...mapGetters(['accounts', 'categories', 'transactions', 'isAccountsLoaded', 'reminders', 'isRemindersLoaded']),

        dashboardAccounts() {
            return this.accounts.filter((account) => {
                return account.is_count;
            });
        },
    },

    methods: {
        ...mapActions(['loadAccounts', 'loadCategories', 'loadTransactions', 'loadReminders', ]),

        loadWidgets(onlyData = false) {
            axios.get(`/dashboard/widgets`)
                .then(({data}) => {
                    this.widgets = data.data;
                }).catch(({response}) => {
                    console.log(response);

                    EventBus.$emit('show-alert', response.data.message, 'error');
                });

            if(onlyData) {
                return;
            }

            axios.get(`/dashboard/widgets/current`)
                .then(({data}) => {
                    this.availableWidgets = data.data.available;
                    this.selectedWidgets = data.data.selected;
                }).catch(({response}) => {
                    console.log(response);

                    EventBus.$emit('show-alert', response.data.message, 'error');
                });
        },

        saveSelectedWidget(position, type) {
            axios.post(`/dashboard/widgets/${position}/${type}`)
                .then(({data}) => {
                    EventBus.$emit('show-alert', data.message, 'success');
                    
                    this.loadWidgets(true);
                }).catch(({response}) => {
                    console.log(response);

                    EventBus.$emit('show-alert', response.data.message, 'error');
                });
        },

        loadMainChart() {
            axios.post(`/reports/main?period=year`)
                .then(({data}) => {
                    this.chartFormat = data.data.format;
                    this.chartData = data.data.values;
                    this.chartText = data.data.text;
                }).catch(({response}) => {
                    EventBus.$emit('show-alert', response.data.message, 'error');
                });
        },

        openReminder(reminder) {
            EventBus.$emit('open-side-form', 'edit-reminder', {reminder: reminder});
        },

        openNewAccountForm() {
            EventBus.$emit('open-side-form', 'new-account');
        },

        openNewReminderForm() {
            EventBus.$emit('open-side-form', 'new-reminder');
        },

        openNewTransactionForm() {
            EventBus.$emit('open-side-form', 'new-transaction');
        },

        transactionDeleted() {
            this.loadTransactions({per_page: 10, page: 1});
            this.loadDashboard();
        },

        statementScrolled(loaded) {
            this.page++;

            this.loadTransactions({per_page: 10, page: this.page}, loaded);
        },

        loadDashboard() {
            axios.get('/dashboard').then(({data}) => {
                    this.balance = data.data.balance;
                    this.today_spend = data.data.today_spend;
                    this.month_spend = data.data.month_spend;
                    this.month_limit = data.data.month_limit;
                    this.budget_today = data.data.budget_today;
                    this.budget_percent = data.data.budget_percent;
                }).catch(({response}) => {
                    EventBus.$emit('show-alert', response.data.message, 'error');
                });
        },

        hideAccount(account) {
            axios.post(`/accounts/${account.id}/hide`)
                .then(({data}) => {
                    EventBus.$emit('show-alert', data.message, 'success');

                    account.is_count = false;

                    this.loadDashboard();
                }).catch(({response}) => {
                    EventBus.$emit('show-alert', response.data.message, 'error');
                });
        },

        deleteAccount(account) {
            if(this.accounts.length === 1) {
                return;
            }

            this.accounts = this.accounts.filter((item) => item.id != account.id);

            axios.delete(`/accounts/${account.id}`)
                .then(({data}) => {
                    EventBus.$emit('show-alert', data.message, 'success');
                    
                    EventBus.$emit('accound-removed');

                    this.loadAccounts();
                }).catch(({response}) => {
                    EventBus.$emit('show-alert', response.data.message, 'error');
                });
        },
    },
}
</script>